import { useId } from "react";

export function CartIcon({
  active = false,
  count = 0,      // availability / stock count
  numInCart = 0,  // quantity currently in user's cart
}) {
  const gradientId = useId();

  const hasCartQty = Number(numInCart) > 0;
  const displayCartQty = numInCart > 99 ? "99+" : numInCart;

  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 44 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradientId} x1="6" y1="6" x2="38" y2="38">
          <stop offset="0" stopColor="#3AA8FF" />
          <stop offset="0.5" stopColor="#6F7CFF" />
          <stop offset="1" stopColor="#A05CFF" />
        </linearGradient>
      </defs>



      {/* Shopping bag body */}
      <path
        d="
          M15.8 18.4
          C15.9 17.35 16.75 16.55 17.8 16.55
          H26.2
          C27.25 16.55 28.1 17.35 28.2 18.4
          L29.05 29.05
          C29.18 30.35 28.15 31.45 26.85 31.45
          H17.15
          C15.85 31.45 14.82 30.35 14.95 29.05
          L15.8 18.4
          Z
        "
        stroke="white"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Handle */}
      <path
        d="
          M18.6 18
          V16.2
          C18.6 14.05 20.05 12.55 22 12.55
          C23.95 12.55 25.4 14.05 25.4 16.2
          V18
        "
        stroke="white"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Quantity in cart badge */}
      {hasCartQty && (
        <g>
          <circle
            cx="36"
            cy="10"
            r="12"
            fill={`url(#${gradientId})`}
            stroke="rgba(0,0,0,0.65)"
            strokeWidth="1.5"
          />

          <text
            x="36"
            y="14.2"
            textAnchor="middle"
            fontSize={numInCart > 99 ? "7.5" : numInCart > 9 ? "9" : "10"}
            fontWeight="900"
            fill="white"
            fontFamily="Arial, Helvetica, sans-serif"
            fontSize="13px"
          >
            {displayCartQty}
          </text>
        </g>
      )}
    </svg>
  );
}